import { useState } from "react";
import { TextField } from "@mui/material";
import DropdownIcon from "../../../components/DropdownIcon/DropdownIcon";

const days = [
  [1, "Bazar ertəsi"],
  [2, "Çərşənbə axşamı"],
  [3, "Çərşənbə"],
  [4, "Cümə axşamı"],
  [5, "Cümə"],
  [6, "Şənbə"],
  [7, "Bazar"],
];

const DaySelect = ({ value, onChange }) => {
  const [openDropdown, setOpenDropdown] = useState(false);
  const selectedDayName =
    days.find(([day]) => day === Number(value))?.[1] || "";

  return (
    <div className="dropdown-input">
      <div className="input-box">
        <TextField
          fullWidth
          label="Gün"
          value={selectedDayName}
          disabled
          onClick={() => setOpenDropdown(!openDropdown)}
          sx={{
            "& input": {
              fontSize: "12px",
            },
            "& .MuiInputLabel-root": {
              fontSize: "12px",
              color: "#3F3F3F",
            },
            "& .MuiOutlinedInput-root": {
              borderRadius: "4px",
              "& fieldset": {
                borderColor: "rgba(118, 118, 118, 0.7)",
                borderWidth: "1px",
              },
              "&:hover fieldset": {
                borderColor: "rgba(118, 118, 118, 0.7)",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#462aff",
                borderWidth: "1px",
              },
            },
          }}
          InputLabelProps={{
            shrink: true,
            style: { fontSize: "12px", color: "#3F3F3F" },
          }}
        />
        <DropdownIcon
          setOpenDropdown={setOpenDropdown}
          openDropdown={openDropdown}
        />
      </div>

      <ul
        className={`dropdown-body where-coming ${openDropdown ? "active" : ""}`}
      >
        {days.map(([day, name]) => (
          <li
            key={day}
            onClick={() => {
              onChange(day);
              setOpenDropdown(false);
            }}
          >
            <h4>{name}</h4>
          </li>
        ))}
      </ul>
    </div>
  );
};

const InputField = ({ title, value, onChange, onAdd, onRemove }) => (
  <div className="worker-plan-schedule">
    <h3>{title}</h3>
    {value.map((item, index) => (
      <div className="worker-plan-schedule-row" key={`${title}-${index}`}>
        <DaySelect
          value={item.day || ""}
          onChange={(day) => onChange(index, "day", day)}
        />
        <div className="input-couples worker-plan-hours">
          <TextField
            label="Başlanğıc saatı"
            type="time"
            value={item.startTime || ""}
            onChange={(event) =>
              onChange(index, "startTime", event.target.value)
            }
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
          <TextField
            label="Bitmə saatı"
            type="time"
            value={item.endTime || ""}
            onChange={(event) => onChange(index, "endTime", event.target.value)}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </div>
        {value.length > 1 && (
          <button type="button" onClick={() => onRemove(index)}>
            Sil
          </button>
        )}
      </div>
    ))}
    <button type="button" onClick={onAdd}>
      Gün əlavə et
    </button>
  </div>
);

export default InputField;